<template>
  <div class="pl-3 pr-3 mb-5">
    <PageTitle title="Cadastro de erros garantia" />

    <b-row class="mt-3">
      <b-col cols="8">
        <label>Marca</label>
        <input
          type="text"
          class="form-control"
          v-model="form.mark"
          placeholder="Digite a marca aqui..."
        />
      </b-col>

      <b-col cols="4">
        <label>Código erro</label>
        <input
          type="text"
          class="form-control"
          v-model="form.error_cod"
          placeholder="####"
        />
      </b-col>

      <b-col cols="12" class="mt-2">
        <label>Como resolver</label>
        <textarea
          id="resolve_error"
          class="form-control"
          v-model="form.resolve_error"
          rows="3"
          placeholder="Descreva a solução aqui..."
        ></textarea>
      </b-col>

      <b-col cols="12" class="mt-2">
        <label>Link do(s) vídeo(s)</label>
        <textarea
          id="resolve_error"
          class="form-control"
          v-model="form.link_video"
          rows="2"
        ></textarea>
      </b-col>

      <b-col cols="12" class="mt-2">
        <label>Link do(s) documento(s)</label>
        <textarea
          id="resolve_error"
          class="form-control"
          v-model="form.link_document"
          rows="2"
        ></textarea>
      </b-col>

      <b-col cols="12" class="text-center mt-4">
        <button class="btn btn-warning pl-4 pr-4 mr-2" @click="defaultForm()">
          Limpar
        </button>
        <button
          class="btn btn-success pl-4 pr-4"
          @click="
            form.id != null ? updateGuaranteeError() : saveGuaranteeError()
          "
        >
          {{ form.id != null ? 'Atualizar' : 'Criar novo' }}
        </button>
      </b-col>

      <b-col cols="12" class="mt-4">
        <table class="table">
          <thead class="letter-orange">
            <tr>
              <th scope="col">Marca</th>
              <th scope="col">Cód. erro</th>
              <th scope="col">Como resolver</th>
              <th scope="col">Vídeo</th>
              <th scope="col">Documento</th>
              <th scope="col">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in errors" v-bind:key="item.id">
              <th scope="row">
                {{ item.mark }}
              </th>
              <td>
                {{ item.error_cod }}
              </td>
              <td>
                {{
                  item.resolve_error
                    ? item.resolve_error.length > 30
                      ? item.resolve_error.substring(0, 30) + '…'
                      : item.resolve_error
                    : ''
                }}
              </td>
              <td>
                {{
                  item.link_video
                    ? item.link_video.length > 30
                      ? item.link_video.substring(0, 30) + '…'
                      : item.link_video
                    : ''
                }}
              </td>
              <td>
                {{
                  item.link_document
                    ? item.link_document.length > 30
                      ? item.link_document.substring(0, 30) + '…'
                      : item.link_document
                    : ''
                }}
              </td>
              <td>
                <div class="btn btn-primary mr-1" @click="editError(item)">
                  <i class="fas fa-edit" aria-label="Editar"></i>
                </div>
                <div class="btn btn-danger" @click="delError(item.id)">
                  <i class="fas fa-trash-alt" aria-label="Excluir"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import makeToast from '@/mixins/makeToast';
import { mapState } from 'vuex';

export default {
  components: {
    PageTitle,
  },

  mixins: [makeToast],

  data() {
    return {
      loading: false,
      errors: [],
      form: {
        id: null,
        mark: '',
        error_cod: '',
        resolve_error: '',
        link_video: '',
        link_document: '',
        construp_user_id: null,
      },
    };
  },

  computed: {
    ...mapState(['token', 'dadosUsuario']),
  },

  mounted() {
    this.get();
  },
  methods: {
    get() {
      this.loading = true;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/getGuaranteeError', this.dadosUsuario.id)
        .then((res) => {
          this.errors = res.data;
        })
        .catch(() => {
          this.makeToast(
            'Erro!',
            'Ocorreu um erro, favor recarregar a página!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },

    saveGuaranteeError() {
      if (
        this.form.error_cod == '' ||
        this.form.mark == '' ||
        this.form.resolve_error == ''
      ) {
        this.makeToast(
          'Atenção!',
          'Os campos Marca, Código erro e Como resolver, são obrigatórios!',
          'warning'
        );
        return;
      }
      this.form.construp_user_id = this.dadosUsuario.id;

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/newGuaranteeError', this.form)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if (response.data.error) {
            this.makeToast('Erro!', response.data.message, 'danger');
            return;
          }

          this.makeToast('Sucesso', response.data.message, 'success');
          this.defaultForm();
          this.get();
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro!', 'Ocorreu um erro', 'danger');
        });
    },

    updateGuaranteeError() {
      if (
        this.form.error_cod == '' ||
        this.form.mark == '' ||
        this.form.resolve_error == ''
      ) {
        this.makeToast(
          'Atenção!',
          'Os campos Marca, Código erro e Como resolver, são obrigatórios!',
          'warning'
        );
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/upGuaranteeError', this.form)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if (response.data.error) {
            this.makeToast('Erro!', response.data.message, 'danger');
            return;
          }

          this.makeToast('Sucesso', response.data.message, 'success');
          this.defaultForm();
          this.get();
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro!', 'Ocorreu um erro', 'danger');
        });
    },

    delError(id) {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/dellGuaranteeError', id)
        .then((response) => {
          this.$store.dispatch('endLoader');
          if (response.data.error) {
            this.makeToast('Erro!', response.data.message, 'danger');
            return;
          }

          this.makeToast('Sucesso', response.data.message, 'success');
          this.defaultForm();
          this.get();
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro!', 'Ocorreu um erro', 'danger');
        });
    },
    editError(item) {
      this.form = item;
    },
    defaultForm() {
      this.form.id = null;
      this.form.mark = '';
      this.form.error_cod = '';
      this.form.resolve_error = '';
      this.form.link_video = '';
      this.form.link_document = '';
      this.form.construp_user_id = null;
    },
  },
};
</script>
